/**
 * useConversations — Phase 4a sidebar list query.
 *
 * Cache key: `['conversations']`. Endpoint: `GET /api/conversations`.
 * Returns DM summaries today (channels ship 4b). Optimistic-update
 * helpers across the chat surface invalidate this cache key on settle so
 * the sidebar always reflects the latest unread / last-message preview.
 */

import { useQuery } from '@tanstack/react-query'

import { apiClient } from '@/api/client'
import { type ChatConversationSummary, normalizeChatConversationSummary } from '@/api/types-bridge'

export const CONVERSATIONS_QUERY_KEY = ['conversations'] as const

export function useConversations() {
  return useQuery({
    queryKey: CONVERSATIONS_QUERY_KEY,
    queryFn: async (): Promise<ChatConversationSummary[]> => {
      const res = await apiClient<{
        data: Parameters<typeof normalizeChatConversationSummary>[0][]
      }>('/api/conversations')
      return res.data.map(normalizeChatConversationSummary)
    },
    staleTime: 30_000,
    refetchOnWindowFocus: false,
    retry: false,
  })
}
